import { render, staticRenderFns } from "./_base-navspinner.vue?vue&type=template&id=3330287a&scoped=true"
import script from "./_base-navspinner.vue?vue&type=script&lang=js"
export * from "./_base-navspinner.vue?vue&type=script&lang=js"
import style0 from "./_base-navspinner.vue?vue&type=style&index=0&id=3330287a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3330287a",
  null
  
)

export default component.exports